import { isServer, type QueryClient } from "@tanstack/react-query";
import { createQueryClient } from "./query-client";

let browserQueryClient: QueryClient;

/**
 * Get a query client works on the server and client
 * @returns QueryClient
 */
export const getQueryClient = () => {
  if (isServer) {
    // Server: always make a new query client
    return createQueryClient();
  }

  // Browser: make a new query client if we don't already have one
  // This is very important, so we don't re-make a new client if React
  // suspends during the initial render. This may not be needed if we
  // have a suspense boundary BELOW the creation of the query client
  if (!browserQueryClient) {
    browserQueryClient = createQueryClient();
  }
  return browserQueryClient;
};
